export function localizedAuthPath(route, path) {
  return route?.path?.startsWith('/en') ? `/en${path}` : path
}